import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { ErrorHandler } from '../../components/ErrorHandler/ErrorHandler'
import { IUser } from '../../api/types/user'
import { UserCard } from './components/UserCard/UserCard'
import { Navbar } from '../../components/Navbar/Navbar'
import { Container, Theme, Typography } from '@mui/material'
import { fromAxiosError } from '../../context/GlobalError'
import { queryUser, userQueryKey } from '../../api/queries'
import { CharacterLoader } from '../Game/components/Character/components/CharacterLoader/CharacterLoader'
import { ICharacter } from '../../api/types/character'
import { CharacterSheet } from '../Game/components/Character/components/CharacterSheet/CharacterSheet'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { CreateCharacter } from '../Game/components/Character/components/CreateCharacter/CreateCharacter'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    panel: {
      flexGrow: 1,
    },
  })
)

interface IParams {
  user_id: string
}

export const UserProfile = () => {
  const { user_id } = useParams<keyof IParams>()
  const classes = useStyles()
  const {
    isLoading: userLoading,
    data: user,
    error,
  } = useQuery<IUser>(userQueryKey(Number(user_id)), () => queryUser(user_id || ''))
  const queryClient = useQueryClient()

  return (
    <>
      <Navbar />
      <ErrorHandler loading={userLoading} error={fromAxiosError(error)}>
        {user && (
          <>
            <Container maxWidth="lg" className={classes.root}>
              <div className={classes.panel}>
                <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
                  Użytkownik
                </Typography>
                <UserCard user={user} />
              </div>

              <div className={classes.panel}>
                <Typography color="text.secondary" variant="overline" display="block" gutterBottom>
                  Postać
                </Typography>
                {!user.character_id && (
                  <CreateCharacter
                    afterCreate={() => queryClient.invalidateQueries(userQueryKey(Number(user_id)))}
                  />
                )}
                {user.character_id && (
                  <CharacterLoader character_id={user.character_id}>
                    {(char: ICharacter) => <CharacterSheet char={char} />}
                  </CharacterLoader>
                )}
              </div>
            </Container>
          </>
        )}
      </ErrorHandler>
    </>
  )
}
